
import React from 'react'

interface TwoColumnLayoutProps {
  title: string
  content: React.ReactNode
  imageSrc: string
  imageAlt: string
  imageFirst?: boolean
  backgroundColor?: string
  titleColor?: string
  textColor?: string
  titleSize?: string
  gap?: string
  contentPadding?: string
}

const TwoColumnLayout = ({
  title,
  content,
  imageSrc,
  imageAlt,
  imageFirst = true,
  backgroundColor = '#FFFFFF',
  titleColor = '#111',
  textColor = '#7B7B7B',
  titleSize = '40px',
  gap = '0',
  contentPadding = '80px'
}: TwoColumnLayoutProps) => {
  return (
    <section
      className="two-column-layout-section"
      style={{ backgroundColor }}
    >
      <div
        className="two-column-row"
        style={{
          backgroundColor: backgroundColor
        }}
      >
        <div
          className={`two-column-grid ${imageFirst ? 'image-first' : ''}`}
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: gap,
            width: '100%',
            margin: '0'
          }}
        >
          {/* Image Column */}
          <div
            className="two-column-image-column"
            style={{
              gridColumn: imageFirst ? '1' : '2',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <img
              src={imageSrc}
              alt={imageAlt}
              style={{
                width: '100%',
                height: '100%',
                minHeight: '560px',
                objectFit: 'cover',
                borderRadius: '0'
              }}
            />
          </div>

          {/* Content Column */}
          <div
            className="two-column-content"
            style={{
              gridColumn: imageFirst ? '2' : '1',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: contentPadding
            }}
          >
            <div style={{ width: '100%' }}>
              <h2
                style={{
                  fontFamily: 'Cardo, serif',
                  fontSize: titleSize,
                  color: titleColor,
                  fontWeight: '400',
                  marginBottom: '32px',
                  lineHeight: '1.2'
                }}
              >
                {title}
              </h2>
              <div
                style={{
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: '16px',
                  lineHeight: '1.6',
                  color: textColor
                }}
              >
                {content}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 1199px) {
          .two-column-grid {
            grid-template-columns: 1fr !important;
            gap: 0 !important;
          }
          
          .two-column-image-column {
            grid-column: 1 !important;
            order: 1;
          }
          
          .two-column-content {
            grid-column: 1 !important;
            order: 2;
          }
          
          .two-column-content > div {
            max-width: 100% !important;
          }
        }

        @media (max-width: 899px) {
          .two-column-grid {
            grid-template-columns: 1fr !important;
            gap: 0 !important;
          }
          
          .two-column-image-column img {
            min-height: 300px !important;
          }
          
          .two-column-content {
            padding: 40px !important;
          }
        }

        @media (min-width: 1200px) {
          .two-column-grid {
            grid-template-columns: 1fr 1fr !important;
          }
          
          .image-first .two-column-image-column {
            grid-column: 1 !important;
          }
          
          .image-first .two-column-content {
            grid-column: 2 !important;
          }
          
          .two-column-grid:not(.image-first) .two-column-image-column {
            grid-column: 2 !important;
          }
          
          .two-column-grid:not(.image-first) .two-column-content {
            grid-column: 1 !important;
          }
        }
      `}</style>
    </section>
  )
}

export default TwoColumnLayout